import apiService from '../../apiService';

const EXPENSE_URL = 'setup/expenses'
const expenseService = {
  
    async createExpense(payload) {
        try {
            const response = await apiService.post(`/${EXPENSE_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllExpense() {
        try {
            const response = await apiService.get(`/${EXPENSE_URL}`,);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


    async getSingleExpense(id) {
        try {
            const response = await apiService.get(`/${EXPENSE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateExpense(payload, id) {
        try {
            const response = await apiService.put(`/${EXPENSE_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteExpense(id) {
        try {
            const response = await apiService.delete(`/${EXPENSE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },



};

export default expenseService;